import type { JSX } from "react";
import { MultiSelectCatFilter } from "packages/vega-core/components/MultiSelectFilter/MultiSelectCatFilter";

import { type NestedOptionType } from "@vega-core/components/Form/Controls/Dropdown/NestedMultiselectDropdown/types";
import { m } from "@vega-core/paraglide/messages";

import {
  type FilterState,
  FilterType,
  type FilterValue,
  type MultiSelectNestedV2FilterConfig,
  type TableFilterId,
} from "../types";
import { getFilterValue } from "../utils/getFilterValue";

type MultiSelectNestedV2FilterProps = {
  disabled?: boolean;
  filter: MultiSelectNestedV2FilterConfig;
  filterState: FilterState;
  isLoading: boolean;
  onFilterChange: (filterId: string, value: FilterValue) => void;
  showLabel?: boolean;
  tableId: TableFilterId;
};

export function MultiSelectNestedV2Filter({
  filter,
  filterState,
  onFilterChange,
  tableId,
  disabled = false,
  isLoading = false,
}: MultiSelectNestedV2FilterProps): JSX.Element {
  const dropdownValue =
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    getFilterValue(filterState, filter.id, FilterType.MultiSelectNestedV2) ??
    ([] as NestedOptionType[]);

  return (
    <MultiSelectCatFilter
      buttonLabel={filter.props.buttonLabel ?? m.btn_select_categories()}
      categories={filter.props.categories}
      disabled={Boolean(disabled || isLoading)}
      name={`${tableId}-${filter.id}`}
      selectedCategories={dropdownValue}
      setSelectedCategories={(items: NestedOptionType[]) =>
        onFilterChange(filter.id, items)
      }
    />
  );
}
